/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Subscriptions_Tab_YearInputs */

const en_admin_subscriptions_tab_year = /** @type {(inputs: Admin_Subscriptions_Tab_YearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yearly`)
};

/**
* | output |
* | --- |
* | "Yearly" |
*
* @param {Admin_Subscriptions_Tab_YearInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_subscriptions_tab_year = /** @type {((inputs?: Admin_Subscriptions_Tab_YearInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Subscriptions_Tab_YearInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_subscriptions_tab_year(inputs)
});
export { admin_subscriptions_tab_year as "admin.subscriptions.tab_year" }